export function initVideoControls() {
	const prefersReducedMotion = window.matchMedia( '(prefers-reduced-motion: reduce)' ).matches;

	document.querySelectorAll( '.video-custom-controls__control' ).forEach( function ( btn ) {
		const video = btn.closest( '.wp-block-cover' ).querySelector( 'video' );
		// Pause video by default if reduced motion is preferred
		if ( video && prefersReducedMotion ) {
			video.pause();
			btn.classList.add( 'is-play' );
			btn.querySelector( '.a11y' ).textContent = btn.dataset.labelPlay;
		}

		btn.addEventListener( 'click', function () {
			if ( video ) {
				if ( video.paused ) {
					video.play();
					this.classList.remove( 'is-play' );
					btn.querySelector( '.a11y' ).textContent = btn.dataset.labelPause;
				} else {
					video.pause();
					this.classList.add( 'is-play' );
					btn.querySelector( '.a11y' ).textContent = btn.dataset.labelPlay;
				}
			}
		} );
	} );
}
